import { NgModule } from '@angular/core';
import { AppPermissionsDirective } from '@core/auth/directives/app-permissions.directive';

/**
 * Módulo compartilhado para a diretiva de permissões.
 * Importar em qualquer módulo que precise usar `appPermissions` nos templates.
 */
@NgModule({
  declarations: [AppPermissionsDirective],
  exports: [AppPermissionsDirective]
})
export class PermissionsModule { }
